import React from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import './MultiSingleDayPicker.scss';

const SingleDay = (props) => {
    const { onRemove, label } = props;
    return (
        <div className="single-day">
            {label}
            <Button onClick={onRemove} className='trash-icon'>
                <FontAwesomeIcon icon={faTimes} />
            </Button>
        </div>
    )
}
export default SingleDay;